import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Mixins } from 'web-common/src/shared/styles';
import { DesktopSearchWrapper as StyledDesktopSearchWrapper } from '../styles';

export const DesktopSearchWrapper = styled(StyledDesktopSearchWrapper)<{ isOpen?: boolean }>`
  display: flex;
  flex-grow: 1;

  ${ifProp(
    'isOpen',
    css`
      justify-content: center;
    `,
    css`
      justify-content: right;
    `
  )}
`;

export const SearchContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  position: relative;

  ${Mixins.Media.maxWidthSmall(css`
    & > * {
      display: flex;
      justify-content: flex-end;
    }
  `)}
`;
